import React, { useContext } from "react";
import { STYLE_DEFAULT_TAB_BED } from "App/constants";

import { TableCell, TableRow } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { headCells } from "./helpers";

import {
  TableWrapper,
  TableCellDefault,
  // InputOptionMaster,
  // InputTextMaster,
  // InputReactDatepicker,
  // InputTextArea,
} from "App/Component/ui";
import { defaultDateDisplay, formatNumber, tipeKartuName, tipePembayaranName } from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";

const useStyles = STYLE_DEFAULT_TAB_BED;

export default function TabPembayaran() {
  const { dataPembayaran } = useContext(FormContext);
  const classes = useStyles();
  // const [formPembayaran, setFormPembayaran] = useState([]);

  // const [rows] = useState();
  // const rows = [];
  // const kasBank = useSelectOption(
  //   true,
  //   "/kas/kas/list",
  //   TYPE_INSTANCE3,
  //   "id",
  //   "nama"
  // );

  // const handleChange = (text) => (e) => {
  //   setFormPembayaran({
  //     ...formPembayaran,
  //     [text]: e.target.value,
  //   });
  // };

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: dataPembayaran,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <div className={classes.root}>
      {/* <Paper style={{ padding: "1rem" }}>
      <Grid container spacing={2}>
        <Grid item sm={12}>
          <InputReactDatepicker
            selected={formPembayaran.tgl}
            label="TANGGAL"
            handleChangeToday={(e) =>
              setFormPembayaran({
                ...formPembayaran,
                tgl: e,
              })
            }
            onChange={(e) =>
              setFormPembayaran({
                ...formPembayaran,
                tgl: e,
              })
            }
          />
        </Grid>
        <Grid item sm={6}>
          <InputOptionMaster
            name="tipe_pembayaran_id"
            label="TIPE PEMBAYARAN"
            id="tipe_pembayaran_id"
            withSearch={false}
            value={formPembayaran.tipe_pembayaran_id}
            onChange={handleChange("tipe_pembayaran_id")}
            data={tipePembayaran}
          />
        </Grid>
        <Grid item sm={6}>
          <InputOptionMaster
            name="kas_id"
            label="KAS"
            id="kas_id"
            data={kasBank}
            withSearch={true}
            value={formPembayaran.kas_id}
            labelValue={formPembayaran.kas_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormPembayaran({
                  ...formPembayaran,
                  kas_id: null,
                  kas_name: "Pilih kas",
                });
              } else {
                setFormPembayaran({
                  ...formPembayaran,
                  kas_id: e?.value,
                  kas_name: e?.label,
                });
              }
            }}
          />
        </Grid>
        <Grid item sm={12}>
          <InputTextMaster
            name="jumlah"
            label="JUMLAH"
            id="jumlah"
            value={formPembayaran.jumlah}
            onChange={handleChange("jumlah")}
            placeholder="Info"
          />
        </Grid>
        <Grid item sm={12}>
          <InputTextArea
            name="remark"
            label="KETERANGAN"
            id="remark"
            value={formPembayaran.remark}
            onChange={handleChange("remark")}
            placeholder="Keterangan"
          />
        </Grid>

        <Grid item sm={12}>
          <InputTextMaster
            name="no_cek"
            label="NO. CEK"
            id="no_cek"
            value={formPembayaran.no_cek}
            onChange={handleChange("no_cek")}
            placeholder="Kode"
          />
        </Grid>
      </Grid>
      </Paper> */}
      <TableWrapper
        title="History Pembayaran"
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={dataPembayaran}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        withPadding={true}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell align="left">{row.id}</TableCell>
                <TableCell align="left">{row.pembelian_id}</TableCell>
                <TableCell align="left">{row.nama_supplier}</TableCell>
                <TableCell align='left'>{row?.faktur_no}</TableCell>
                <TableCell align='left'>{row?.idgl}</TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row.tanggal_masuk, true)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.jumlah_bayar)}
                </TableCell>
                <TableCell align="left">{row?.kas_name}</TableCell>
                <TableCell align="left">
                  {tipePembayaranName(row.tipe_pembayaran_id)}
                </TableCell>
                <TableCell align="left">
                  {tipeKartuName(row.tipe_kartu)}
                </TableCell>
                <TableCell align="left">{row.no_kartu}</TableCell>
                <TableCell align="left">{row.no_transfer}</TableCell>
                <TableCellDefault type={"custom"} row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
